;(function () {
  let multicolumnSlider
  let autoplayInterval

  const initSlider = (slider, isMobile = false) => {
    if (slider.classList.contains('swiper-initialized')) return
    slider.classList.add('swiper', 'swiper-initialized')

    const wrapper = slider.querySelector('.multicolumn-list__wrapper')
    if (!wrapper) return

    wrapper.classList.add('swiper-wrapper')

    const slides = slider.querySelectorAll('.multicolumn-card')
    if (!slides || !slides.length) return

    slides.forEach((slide) => {
      slide.classList.add('swiper-slide')
      slide.addEventListener('mouseenter', pauseAutoplay)
      slide.addEventListener('mouseleave', startAutoplay)
    })

    if (!isMobile) {
      slides.forEach(slide => {
        const clone = slide.cloneNode(true)
        clone.classList.add('swiper-slide-clone')
        wrapper.appendChild(clone)
      })
    }


    const section = slider.closest('section')
    const columnsToShow = section?.dataset?.columns ? parseInt(section.dataset.columns) : 4

    const config = {
      speed: isMobile ? 1000 : 800,
      mousewheel: {
        forceToAxis: true,
      },
      spaceBetween: isMobile ? 20 : 30
    }

    if (isMobile) {
      config.slidesPerView = 1.1
    } 
    else {
      config.freeMode = true
      config.loop = false
      config.slidesPerView = columnsToShow
    }

    multicolumnSlider = new Swiper(slider, config)

    if (!isMobile) {
      startAutoplay()
    }
  }

  const startAutoplay = () => {
    if (!multicolumnSlider || autoplayInterval || window.innerWidth < 990) return

    const wrapper = multicolumnSlider.wrapperEl
    let translateX = 0
    const speed = 1 
    const totalWidth = wrapper.scrollWidth / 2

    autoplayInterval = setInterval(() => {
      translateX -= speed
      if (translateX <= -totalWidth) translateX = 0
      wrapper.style.transform = `translateX(${translateX}px)`
    }, 16)
  }

  const pauseAutoplay = () => {
    if (autoplayInterval) {
      clearInterval(autoplayInterval)
      autoplayInterval = null
    }
  }

  const destroySlider = (section) => {
    if (!section || !section.classList.contains('multicolumn-section')) return

    pauseAutoplay()

    const slider = section.querySelector('.multicolumn-slider')
    const slides = section.querySelectorAll('.multicolumn-card')
    const wrapper = section.querySelector('.multicolumn-list__wrapper')

    if (!slider || !slides || !slides.length || !wrapper) return

    slides.forEach((slide) => {
      slide.removeEventListener('mouseenter', pauseAutoplay)
      slide.removeEventListener('mouseleave', startAutoplay)
    })

    slider.classList.remove('swiper', 'swiper-initialized')
    slides.forEach((slide) => slide.classList.remove('swiper-slide'))
    wrapper.classList.remove('swiper-wrapper')

    if (multicolumnSlider) {
      multicolumnSlider.destroy(true, true)
      multicolumnSlider = null
    }
  }

  const initMulticolumn = (section) => {
    if (!section || !section.classList.contains('multicolumn-section')) return

    const slider = section.querySelector('.multicolumn-slider')
    if (!slider) return

    const columnsToShow = section.settings?.multicolumn_to_show || 4
    section.dataset.columns = columnsToShow

    const handleResize = () => {
      const width = window.innerWidth
      if (width < 990) {
        pauseAutoplay()
        if (multicolumnSlider && multicolumnSlider.params.slidesPerView !== 1.1) {
          destroySlider(section)
          initSlider(slider, true)
        } else if (!multicolumnSlider) {
          initSlider(slider, true)
        }
      } else {
        if (multicolumnSlider && multicolumnSlider.params.slidesPerView === 1.1) {
          destroySlider(section)
          initSlider(slider, false)
        } else if (!multicolumnSlider) {
          initSlider(slider, false)
        } else {
          startAutoplay()
        }
      }
    }

    const sectionResizeObserver = new ResizeObserver(() => handleResize())
    sectionResizeObserver.observe(section)
    
    handleResize()
  }

  const currentSection = document.currentScript.parentElement
  if (multicolumnSlider) destroySlider(currentSection)
  initMulticolumn(currentSection)

  document.addEventListener('shopify:section:load', function (e) {
    if (multicolumnSlider) destroySlider(e.target)
    initMulticolumn(e.target)
  })

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990 && multicolumnSlider && !autoplayInterval) {
      startAutoplay()
    } else if (window.innerWidth < 990) {
      pauseAutoplay()
    }
  })
})()